export default {
  SUPER_ADMIN: '_super_admin',
  ADMIN: '_admin',
  COMPTA: '_compta',
  IN_CHARGE: '_in_charge',
  ANIMATEUR: '_animateur',
  RECEPTIONIST: '_receptionist',
  CEE_ADMIN: '_cee_admin',
  MINIBUS_ADMIN: '_minibus_admin',
};
